<template>
  <div class="asso-team-portal">
    <TournamentAddGameModal
      :association_id="association_id"
      :eventId="eventId"
    />
    <div v-if="currentIsUmpire === 1 || currentIsUmpire === '1'">
      <div
        class="asso-sec-content umpire-section"
        v-if="tournamentGame.length > 0 && showUmpireSchedule"
      >
        <h6>My Schedule</h6>
        <EventGames :tournamentGame="tournamentGame" :showLoader="showLoader" :currentIsAdmin="currentIsAdmin" :association_id="association_id" :currentIsUmpire="currentIsUmpire" />
      </div>
    </div>

    <div
      class="asso-sec-content"
      v-if="tournamentsData.length > 0"
      :class="{ 'mt-3': tournamentGame.length > 0 }"
    >
      <div
        class="d-flex justify-content-between flex-wrap align-items-center"
        style="gap: 5px;"
      >
        <!-- Tournament Dropdown -->
        <div class="position-relative">
          <div
            class="switch-btn switch-btn-two mb-0 d-flex flex-row align-items-center"
            @click="toggleDropdown"
            v-click-outside="closeDropdown"
          >
            <div>
              <span>Switch Division</span>
              <p class="association-data">
                {{ selectedTournamentName || "Select Division" }}
              </p>
              <small class="association-tournament-date">{{
                selectedTournamentDate
              }}</small>
            </div>
            <img :src="arrow_down" alt="arrow-down" />
          </div>

          <div
            class="dropdown-menu-content"
            v-if="activeDropdown"
          >
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search Division"
              @click.stop
              @input="onSearchInput"
            />
            <div v-if="filteredTournaments.length === 0" class="no-results">
              No results found
            </div>
            <div class="dropdown-menu-content-inner" ref="dropdownMenu" v-else>
              <div
                v-for="tournament in filteredTournaments"
                :key="tournament.guid"
                class="dropdown-item"
                @click="selectTournament(tournament)"
              >
                <span>{{ tournament.tournamentName }}</span>
              </div>
              <div
                class="position-relative py-3"
                v-if="showLoaderTournament === 1"
              >
                <div class="lds-dual-ring-media"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="d-flex justify-content-end" style="gap: 5px;" v-if="currentIsAdmin == '1'">
                    <button class="btn manage-btn" @click="callModal(selectedTournament)">
                        Create Pool Games
                    </button>
                    <button class="btn manage-btn" data-toggle="modal" data-target="#bracketModal">
                        Create Bracket
                    </button>
                </div> -->
      </div>
      <!-- <AssociationTeamWinning /> -->
      <div class="team-wrapper-content">
        <TournamentTeams
          :tournamentData="tournamentsData"
          :selectedTournamentObj="selectedTournamentObj"
          :showLoader="showLoaderTournament"
          :currentIsAdmin="currentIsAdmin"
          :currentIsUmpire="currentIsUmpire"
          :association_id="association_id"
          :events="eventData"
        />
      </div>
      <div class="umpire-warning-box mt-3" v-if="(currentIsAdmin == 1 || currentIsAdmin == '1') && hasGames && (poolNonUmpireGames > 0 || bracketNonUmpireGames > 0)">
        <div class="umpire-warning-title">
          <img src="../../assets/Svg/warning-2.svg" alt="umpire-assignment" />
          <span>Umpire Assignment Incomplete</span>
        </div>
        <div class="umpire-warning-text">
          Some games are missing umpire assignments. Please review and assign
          umpires to finalize the schedule.
          <ul>
            <li>Pool Games: {{ poolNonUmpireGames }} unassigned</li>
            <li>Bracket Games: {{ bracketNonUmpireGames }} unassigned</li>
          </ul>
        </div>
        <a class="assign-umpires-btn" @click="showUmpireAssignmentDiv"
          >Assign Umpires</a
        >
      </div>
      <AssociationGameListing
        :currentIsAdmin="currentIsAdmin"
        :currentIsUmpire="currentIsUmpire"
        :association_id="association_id"
        :tournamentData="tournamentsData"
        @games-loaded="handleGamesLoaded"
      />
    </div>
    <div class="bracket-wrapper-content mt-3">
      <!-- <TournamentBrackets
        :currentIsAdmin="currentIsAdmin"
        :currentIsUmpire="currentIsUmpire"
        :association_id="association_id"
        :tournamentData="tournamentsData"
      /> -->
      <BracketsView
      :currentIsAdmin="currentIsAdmin"
        :currentIsUmpire="currentIsUmpire"
        :association_id="association_id"
        :tournamentData="tournamentsData"
      />
    </div>
  </div>
</template>

<script>
// import TournamentBrackets from "../Tournaments/TournamentBrackets.vue";
import BracketsView from "../Tournaments/BracketsView.vue";
import TournamentTeams from "../Tournaments/TournamentTeams.vue";
import EventGames from "../Tournaments/EventGames.vue";
import TournamentAddGameModal from "../Tournaments/Modals/TournamentAddGameModal.vue";
import axios from "axios";
// import AssociationTeamWinning from "./AssociationTeamWinning.vue";
import AssociationGameListing from "./AssociationGameListing.vue";
import moment from "moment";

export default {
  name: "AssociationScheduleInfo",
  components: {
    // TournamentBrackets,
    BracketsView,
    TournamentTeams,
    EventGames,
    TournamentAddGameModal,
    // AssociationTeamWinning,
    AssociationGameListing,
  },
  data() {
    return {
      searchQuery: "",
      showUmpireSchedule: true,
      showLoader: 1,
      tournamentGame: [],
      selectedTournament: null,
      activeDropdown: false,
      previousScrollTop: 0,
      arrow_down: require("@/assets/Svg/arrow-down.svg"),
      events: {},
      selectedTournamentObj: {},
      selectedFilter: localStorage.getItem("gameFilter") || "all", // Default filter

      poolNonUmpireGames: 0,
      bracketNonUmpireGames: 0,

      hasGames: false,
    };
  },
  computed: {
    selectedTournamentName() {
      const tournament = this.tournamentsData.find(
        (t) => t.guid === this.selectedTournament
      );
      return tournament ? tournament.tournamentName : "";
    },
    selectedTournamentDate() {
      const tournament = this.tournamentsData.find(
        (t) => t.guid === this.selectedTournament
      );
      if (!tournament || !tournament.exactStartDate || !tournament.exactEndDate)
        return "";

      const start = new Date(tournament.exactStartDate);
      const end = new Date(tournament.exactEndDate);

      const format = (date) => {
        const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
        const month = date.toLocaleDateString("en-US", { month: "short" });
        const day = date.getDate();
        return `${weekday} ${month} ${day}`;
      };

      return `${format(start)} - ${format(end)}, ${end.getFullYear()}`;
    },
    sortedTournaments() {
      if (!this.tournamentsData) return [];
      return [...this.tournamentsData].sort((a, b) => {
        const nameA = (a.tournamentName || "").toUpperCase();
        const nameB = (b.tournamentName || "").toUpperCase();
        return nameA.localeCompare(nameB);
      });
    },
    filteredTournaments() {
      const query = this.searchQuery.trim().toLowerCase();
      return this.sortedTournaments.filter((t) =>
        (t.tournamentName || "").toLowerCase().includes(query)
      );
    },
  },
  watch: {
    tournamentGame: {
      handler() {
        this.$nextTick(() => {
          this.checkScheduleVisibility();
        });
      },
      deep: true,
    },
    tournamentsData: {
      handler(newData) {
        if (!newData || newData.length === 0) return;

        // Create a sorted copy
        const sortedData = [...newData].sort((a, b) => {
          const nameA = (a.tournamentName || "").toUpperCase();
          const nameB = (b.tournamentName || "").toUpperCase();
          return nameA.localeCompare(nameB);
        });

        const storedTournamentID = localStorage.getItem("tournamentID");

        if (storedTournamentID) {
          this.selectedTournament = storedTournamentID;
        } else {
          this.selectedTournament = sortedData[0].guid;
          localStorage.setItem("tournamentID", this.selectedTournament);
        }
        // ✅ Find and store the full tournament object
        this.selectedTournamentObj = sortedData.find(
          (t) => t.guid === this.selectedTournament
        );
      },
      immediate: true,
    },

    currentIsUmpire: {
      immediate: true,
      handler(umpire) {
        if (umpire === 1 || umpire === "1") {
          this.getTournamentDetail();
        }
      },
    },
  },
  mounted() {
    this.getEventGamesSchedule();
    this.$root.$on("hideSchedule", this.hideUmpireSection);

    // Option 2: Check visibility when component mounts
    this.$nextTick(() => {
      this.checkScheduleVisibility();
    });
  },
  beforeDestroy() {
    this.$root.$off("hideSchedule", this.hideUmpireSection);
  },

  props: {
    tournamentsData: {
      type: Array,
    },
    showLoaderTournament: {
      type: Number,
    },
    currentIsUmpire: {
      type: String,
    },
    currentIsAdmin: {
      type: String,
    },
    eventId: {
      // Define umpires prop to receive the umpire data
      type: [Number, String],
    },
    association_id: {
      type: [Number, String],
    },
    divisionPage: {
      type: Number,
    },
    divisionlastPage: {
      type: Number,
    },
    eventData: {
      type: Object,
    },
  },
  methods: {
    handleGamesLoaded(gameList) {
      this.hasGames = gameList.length > 0;
    },
    hideUmpireSection() {
      this.showUmpireSchedule = false;
      console.log("Umpire schedule hidden");
    },
    checkScheduleVisibility() {
  const games = this.tournamentGame || [];
  if (!games.length) {
    this.showUmpireSchedule = false;
    return;
  }
  
  const today = moment();
  const userId = Number(localStorage.getItem('userId'));
  
  // Check if there is at least one game within the event date range
  const hasValidDateRangeGame = games.some((game) => {
    const eventStart = moment(game?.event?.exactStartDate, "MMM DD, YYYY");
    const eventEnd = moment(game?.event?.exactEndDate, "MMM DD, YYYY");
    const gameStart = moment(game?.start_date);
          console.warn(" game:", { eventStart, eventEnd, gameStart });

    if (!eventStart.isValid() || !eventEnd.isValid() || !gameStart.isValid()) {
      console.warn("Invalid date(s) in game:", { eventStart, eventEnd, gameStart });
      return false;
    }
    
    return gameStart.isBetween(eventStart, eventEnd, 'day', '[]'); // inclusive
  });
  
  // Check if the user is assigned as umpire in any game WITHIN the event date range
  const userHasGamesInEventRange = games.some((game) => {
    const eventStart = moment(game?.event?.exactStartDate, "MMM DD, YYYY");
    const eventEnd = moment(game?.event?.exactEndDate, "MMM DD, YYYY");
    const gameStart = moment(game?.start_date);
    
    if (!eventStart.isValid() || !eventEnd.isValid() || !gameStart.isValid()) {
      return false;
    }
    
    // Check if game is within event date range
    const isGameInRange = gameStart.isBetween(eventStart, eventEnd, 'day', '[]');
    
    // Check if user is assigned to this game
    const isUserAssigned = (
      game.umpire_id == userId ||
      (Array.isArray(game.umpires) && game.umpires.includes(userId))
    );
    
    return isGameInRange && isUserAssigned;
  });
  
  // Check if the event has ended
  const eventEndRaw = games?.[0]?.event?.exactEndDate;
  const eventEndDate = moment(eventEndRaw, "MMM DD, YYYY");
  const isEventOver = eventEndDate.isBefore(today, "day");
  
  // Final condition to show or hide the schedule
  // Show schedule if:
  // 1. User has games assigned within the event date range, AND
  // 2. Event hasn't ended, AND  
  // 3. There are valid games in the event date range
  // 
  // Hide schedule if:
  // - Event has ended AND user has no games in the event range
  // - OR no valid games in event range
  // - OR event has ended (regardless of game assignment)
  
  if (isEventOver) {
    // If event is over, don't show schedule regardless of game assignments
    this.showUmpireSchedule = false;
  } else {
    // Event is ongoing, show only if user has games in the event range and there are valid games
    this.showUmpireSchedule = userHasGamesInEventRange && hasValidDateRangeGame;
  }
  
  console.log("Umpire schedule visibility checked:", {
    showUmpireSchedule: this.showUmpireSchedule,
    userHasGamesInEventRange,
    isEventOver,
    hasValidDateRangeGame
  });
},
    showUmpireAssignmentDiv() {
      this.$router.push({
        name: "PoolPlayGenerator",
        params: { id: this.eventData.guid },
        query: { view: 'umpire' }
      });
    },

    onSearchInput(e) {
      this.searchQuery = e.target.value;
    },
    // callModal(tournament) {
    //     this.$root.$emit("openTournamentAddGameModal", tournament);
    // },
    toggleDropdown() {
      this.searchQuery = "";
      this.activeDropdown = !this.activeDropdown;

      this.$nextTick(() => {
        if (this.activeDropdown && this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.addEventListener(
            "scroll",
            this.onDropdownScroll
          );
        } else if (this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.removeEventListener(
            "scroll",
            this.onDropdownScroll
          );
        }
      });
    },
    onDropdownScroll() {
      console.log("calling down")
      this.$emit("get-division-pagination");
    },
    closeDropdown() {
      this.activeDropdown = false;
    },
    selectTournament(tournament) {
      this.selectedTournament = tournament.guid;
      this.$root.$emit("changeDivision", this.selectedTournament);
      localStorage.setItem("division", this.selectedTournament);

      // Set selectedTournamentObj
      this.selectedTournamentObj = this.tournamentsData.find(
        (t) => t.guid === this.selectedTournament
      );

      this.closeDropdown();
    },
    async getEventGamesSchedule() {
      var url = window.location.pathname;
      var segment_array = url.split("/");
      var eventGuid = segment_array.pop();

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/getEventGamesSchedule`,
          { params: { event_guid: eventGuid } }
        );

        if (response.data.statusCode === 200) {
          this.poolNonUmpireGames =
            response.data.data.umpireStats.pool_game_without_umpire;
          this.bracketNonUmpireGames =
            response.data.data.umpireStats.bracket_game_without_umpire;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getTournamentDetail() {
      var url = window.location.pathname;
      var segment_array = url.split("/");
      const tournamentGuid = segment_array.pop();
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/getEventGames`,
          { event_guid: tournamentGuid }
        );

        if (response.data.statusCode === 200) {
          this.tournamentGame =
            response.data.data.tournamentGames &&
            response.data.data.tournamentGames
              ? response.data.data.tournamentGames
              : [];
          this.events = response.data.data.teamEventData;
          this.currentIsAdmin = this.events.currentIsAdmin === "1" ? "1" : "0";
          this.currentIsUmpire = this.events.currentIsAdmin === "0" ? "0" : "1";
          this.showLoader = 0;
        } else if (
          response.data.statusCode === 404 ||
          response.data.statusCode === 403
        ) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoader = 0;
        } else if (response.data.statusCode === 400) {
          this.showLoader = 0;
          this.$alert("Tournament not found").then(() => {
            window.history.back();
          });
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
    },
    filterGames(filter) {
      this.selectedFilter = filter;
      localStorage.setItem("gameFilter", this.selectedFilter);
      this.$root.$emit("FilterGames", this.selectedFilter);
    },
  },
};
</script>
